<template>
    <div>
        <div
            :class="[{'is-suspend': reserveBtnSuspend && needBottom}, 'gp-app-reserve-sticky']"
            :data-pblog="pblogData"
            class="pb-show-display"
        >
            <div v-if="hasApk" :class="[{'is-bottom': reserveBtnSuspend && needBottom}, 'gp-app-reserve-sticky__text']">
                <div>
                    游戏公测后将第一时间更新为正式包，并获得专属礼包
                </div>
            </div>
            <div class="gp-app-reserve-sticky__download">
                <div v-if="!isReservedInTieba" class="light bgColour"></div>
                <div v-if="!isReserved && !hasApk && !status" class="button" @click="reserve">立即预约</div>
                <div
                    v-if="isReserved && !hasApk || status"
                    class="button"
                    :class="{'is-reserved-in-tieba': isReservedInTieba}"
                    @click="cancelReserve"
                >已预约</div>
                <div v-if="hasApk" class="button" @click="rushDownload">抢先下载</div>
            </div> 
        </div>
        <div v-if="showMask" class="gp-app-reserve-mask">
            <div v-if="hasApk && !isCancelReserve" class="gp-app-reserve-mask__dialog dialog-size">
                <div class="title">预约成功</div>
                <div class="words">正在下载专属下载器，游戏上线后打开下载器可升级正式版本，并获得专属礼包</div>
                <div class="confirm" @click="confirm">知道了</div>
            </div>
            <div v-if="!hasApk && !isCancelReserve" class="gp-app-reserve-mask__phone-dialog dialog-size">
                <div class="title">预约游戏</div>
                <div class="words">游戏上线后将通过短信通知您</div>
                <div class="input-container">
                    <span class="phone-prefix">+86</span>
                    <input 
                        ref="confirm"
                        v-model="iphone"
                        type="text" 
                        class="phone-number" 
                        placeholder="请输入手机号"       
                    > 
                </div>
                <div v-if="warning" class="warning">请输入正确手机号码</div>
                <div class="submit">
                    <div class="close" @click="close('close')">关闭</div>
                    <div class="confirm" @click="confirm('smsNotice')">使用短信通知</div>
                </div>
            </div>
            <div v-if="isCancelReserve" class="gp-app-reserve-mask__cancel-reserve-dialog dialog-size">
                <div class="words">取消预约后将无法获得专属福利，确定要放弃预约吗？</div>
                <div class="operation">
                    <div class="confirm" @click="confirm('determine')">确定</div>
                    <div class="close" @click="close('noCancel')">暂不取消</div>
                </div>
            </div>
        </div>
        <div
            class="tb-reserve-success-toast"
            :class="{'is-show': isShowReserveSuccessToast}"
        >
            <img class="icon" :src="appDoc.icon_url">
            <div class="info">
                <div class="title">{{ appDoc.app_name }}预约成功！</div>
                <div class="sub-title">上线后wifi自动下载，可在下载管理查看</div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api';
    import { on } from '@/utils/dom';
    import { throttle } from 'throttle-debounce';
    import { getQueryString } from '@/utils/url';
    import { downloadApk } from '@/utils/browser';
    import tbNAPI from '@baidu/tb-napi';
    import {eventBus} from '@/pages/newdetail/index';
    const isTiebaApp = tbNAPI.env.isTBAPP;
    const APP_RESERVE_KEY = 'APP_RESERVE_KEY';
    
    export default {
        props: {
            appDoc: {
                type: Object,
                required: true
            },
            needBottom: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                reserveBtnSuspend: false,
                showMask: false,
                isReserved: false,
                warning: false,
                isCancelReserve: false,
                hasApk: this.appDoc.download_url,
                iphone: '',
                showToast: false,
                toastText: '',
                status: +getQueryString('status') === 1,
                pblogData: {},
                isShowReserveSuccessToast: false,
            }
        },
        computed: {
            isReservedInTieba() {
                return isTiebaApp && this.isReserved;
            },
        },
        created() {
            this.checkIsReserved();
            const { app_name, app_id, app_type } = this.appDoc;
            this.pblogData = JSON.stringify({
                value: 'game',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: {
                                gameName: app_name,
                                srcId: getQueryString('srcid') || '',
                                sid: getQueryString('sid'),
                                gameId: app_id,
                                gameType: app_type,
                                clickType: 'gameBtn',
                                clickBtnType: 'book',
                                clickBtnPos: this.position
                            },
                            pos: ''
                        }
                    ]
                }
            });
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    on(window, 'scroll', throttle(200, this.suspendLangBtn));
                    // 页面中有两个预约按钮，一个在页面中间，一个在页面底部，所以当其中一个预约按钮点击预约完成后要同步更新另一个按钮的状态
                    eventBus.$on(APP_RESERVE_KEY, isReserved => {
                        this.isReserved = isReserved;
                    });
                }, 200);
            });
            document.addEventListener('visibilitychange', this.checkIsReserved);
        },
        methods: {
            checkIsReserved() {
                const params = {
                    data: {
                        'app_id': getQueryString('appid'),
                        'zoneAppId': getQueryString('zoneAppId'),
                        'package_name': this.appDoc.package_name || '',
                        'isFromTieba': isTiebaApp ? '1' : '0',
                        'cid': getQueryString('cid'),
                    },
                };
                api.newdetail.getBookedInfo(params).then(res => {
                    if (+res.isAppointment === 1 || +res.isAppointment === 2) {
                        this.isReserved = true;
                    }
                    this.iphone = res.iphone;
                }).catch(err => {
                    console.log(err);
                });
            },
            suspendLangBtn() {
                const langBtnContainer = document.getElementById('gp_show_head');
                const {bottom} = langBtnContainer?.getBoundingClientRect();
                if (bottom < 50) {
                    this.reserveBtnSuspend = true;
                } else {
                    this.reserveBtnSuspend = false;
                }
            },
            reserve() {
                let pos = this.reserveBtnSuspend ? 'bottomFixed' : 'inPage';
                this.doClickLog('order', pos);
                if (isTiebaApp) { // 贴吧端内不需要填手机号预约
                    this.addNewReserve();
                    this.isReserved = true;
                } else {
                    this.showMask = true;
                    this.$root.$data.videoView = false;
                }
            },
            addNewReserve() {
                let params = {
                    data: {
                        app_id: getQueryString('appid'),
                        zoneAppId: getQueryString('zoneAppId'),
                        product: 'wise',
                        cid: getQueryString('cid'),
                        app_name: this.appDoc.app_name || '',
                    }
                }
                if (!this.hasApk && this.iphone) {
                    params['iphone'] = this.iphone;
                }
                if (isTiebaApp) {
                    params.data.isFromTieba = '1'; // 贴吧端内预约不需要填手机号，传标识即可
                }
                let that = this;
                api.newdetail.addNewBooked(params).then(() => {
                    if (isTiebaApp) {
                        this.handleReserveSuccessInTieba();
                    } else {
                        that.$toast('预约成功');
                    }
                    eventBus.$emit(APP_RESERVE_KEY, true);
                }).catch(err => {
                    console.log(err);
                })
            },
            handleReserveSuccessInTieba() {
                if (tbNAPI.canIUse('subscription.notifyNativeRefresh')) { // 贴吧端内预约成功后，需要给端发通信
                    tbNAPI.subscription.notifyNativeRefresh({
                        key: 'feed.jointGameSubscribeState',
                        data: {
                            game_id: getQueryString('zoneAppId'),
                            state: '1',
                        },
                        success: res => {
                            console.log('通知端成功', res);
                        },
                        fail: err => {
                            console.log('通知端失败', err);
                        },
                    });
                }
                this.isShowReserveSuccessToast = true;
                const timer = setTimeout(() => {
                    this.isShowReserveSuccessToast = false;
                    clearTimeout(timer);
                }, 4000);
            },
            confirmCancelReserve() {
                this.showMask = false;
                this.isReserved = false;
                this.isCancelReserve = false;
                let params = {
                    data: {
                        app_id: getQueryString('appid'),
                        zoneAppId: getQueryString('zoneAppId'),
                    }
                }
                if (!this.hasApk && this.iphone) {
                    params['iphone'] = this.iphone
                }
                if (isTiebaApp) {
                    params.data.isFromTieba = '1'; // 贴吧端内预约不需要填手机号，传标识即可
                }
                api.newdetail.cancelBooked(params).then(res => {
                    eventBus.$emit(APP_RESERVE_KEY, false);
                    return res;
                }).catch(err => {
                    console.log(err);
                })
            },
            confirm(value) {
                const {logo, package_name, download_url} = this.appDoc;
                let name = "短信预约";
                if (value === 'determine') {
                    name = "取消预约";
                }
                this.doDialogClickLog(value, name);
                if (this.isCancelReserve) {
                    this.status = false;
                    let url = location.href.replace('status=1', 'status=0');
                    history.replaceState(null, '', url);
                    this.confirmCancelReserve();
                    this.$root.$data.videoView = true;
                    return;
                }
                if (this.hasApk) {
                    this.addNewReserve();
                    downloadApk(download_url, logo, package_name, 'cb');
                    this.showMask = false;
                    this.isReserved = true;
                    this.$root.$data.videoView = true;
                    return;
                } else {
                    if (!(/^1[3456789]\d{9}$/.test(this.iphone))) { 
                        this.warning = true;
                    } else {
                        this.addNewReserve();
                        this.warning = false;
                        this.isReserved = true;
                        this.showMask = false;
                        this.$root.$data.videoView = true;
                    } 
                }
            },
            close(value) {
                this.$root.$data.videoView = true;
                this.warning = false;
                this.showMask = false;
                this.isCancelReserve = false;
                let name = "短信预约";
                if (value === 'noCancel') {
                    name = "取消预约";
                }
                this.doDialogClickLog(value, name);
            },
            cancelReserve() {
                if (this.isReservedInTieba) { // 贴吧内无取消预约逻辑
                    return;
                }
                this.$root.$data.videoView = false;
                this.showMask = true;
                this.isCancelReserve = true;
                let pos = this.reserveBtnSuspend ? 'bottomFixed' : 'inPage';
                this.doClickLog('ordered', pos);
            },
            rushDownload() {
                const {logo, package_name, download_url} = this.appDoc;
                downloadApk(download_url, logo, package_name, 'cb');
                let pos = this.reserveBtnSuspend ? 'bottomFixed' : 'inPage';
                this.doClickLog('downloadFirst', pos);
            },
            doClickLog(type,pos) {
                const {package_name, app_name, app_id, app_type} = this.appDoc;
                const {browserVersion, browserName} = window.detailUserAgentInfo;
                this.$logger.click({
                    value: 'game',
                    ext:{
                        id: package_name,
                        ext: {
                            gameName: app_name,
                            srcId: getQueryString('srcid') || '',
                            sid: getQueryString('sid'),
                            tid: getQueryString('tid'),
                            cid: getQueryString('cid') || '',
                            channelid: getQueryString('channelid'),
                            game_id: getQueryString('zoneAppId') || '',
                            position: getQueryString('position') || '',
                            fid: getQueryString('fid') || '',
                            fname: getQueryString('fname') || '',
                            gameId: app_id,
                            gameType: app_type,
                            browserVersion,
                            browserName,
                            clickType: 'gameBtn',
                            clickBtnType: type,
                            clickBtnPos: pos
                        },
                        pos: ''
                    },
                    network: this.$wifi ? 'wifi' : '4g'
                });
            },
            doDialogClickLog(value, name) {
                const {package_name, app_name, app_id, app_type} = this.appDoc;
                const {browserVersion, browserName} = window.detailUserAgentInfo;
                this.$logger.click({
                    value: value,
                    ext:{
                        id: package_name,
                        ext: {
                            gameName: app_name,
                            srcId: getQueryString('srcid') || '',
                            sid: getQueryString('sid'),
                            tid: getQueryString('tid'),
                            cid: getQueryString('cid') || '',
                            channelid: getQueryString('channelid'),
                            gameId: app_id,
                            gameType: app_type,
                            browserVersion,
                            browserName,
                            popupName: name
                        },
                        pos: ''
                    },
                    network: this.$wifi ? 'wifi' : '4g'
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/mixins";
    @import "~@/common/style/mixin/border";
    $design-width: 1242;
    @keyframes seepmove {
        0% {
            -webkit-transform: translateX(px2rem(-800));
            transform: translateX(px2rem(-800));
        }
        40% {
            -webkit-transform: translateX(px2rem(-800));
            transform: translateX(px2rem(-800));
        }
        100% {
            -webkit-transform: translateX(150vw);
            transform: translateX(150vw);
        }
    }

    @keyframes seepMoveOfColour {
        0% {
            -webkit-transform: translateX(px2rem(-800));
            transform: translateX(px2rem(-800));
        }
        40% {
            -webkit-transform: translateX(px2rem(-800));
            transform: translateX(px2rem(-800));
        }
        100% {
            -webkit-transform: translateX(150vw);
            transform: translateX(150vw);
        }
    }

    @include b(app-reserve-sticky) {
        width: 100%; 
        background: #fff;
        @include when(suspend) {
            position: fixed;
            bottom: 0;
            left: px2rem(0);
            z-index: 30;
        }
        @include e(text) {
            margin-top: px2rem(45);
            padding: 0 px2rem(51);
            @include when(bottom) {
                margin-top: 0;
                border-top: 1px solid #E6E6E6;
                div {
                    border: none;
                }
            }
            div {   
                padding-top: px2rem(40); 
                font-size: px2rem(39);
                color: #999;
                white-space:nowrap;
                overflow:hidden;
                text-overflow:ellipsis;
                border-top: 1px solid #E6E6E6;
            }
        } 
        @include e(download) {
            position: relative;
            height: px2rem(200);
            display: flex;
            align-items: center;
            justify-content: center;
            .light {
                transform: translateX(px2rem(-800));
                position: absolute;
                left: 0px;
                top: 0px;
                height: 100%;
                width: px2rem(800);
                opacity: .7;
                background: linear-gradient(110deg, rgba(255,255,255,0), rgba(255,255,255,0.5), rgba(255,255,255,0));
                -webkit-animation: 2.5s seepmove ease-in-out infinite normal;
                animation: 2.5s seepmove ease-in-out infinite normal;
                .bgColour {
                    -webkit-animation: 2.5s seepMoveOfColour ease-in-out infinite normal;
                    animation: 2.5s seepMoveOfColour ease-in-out infinite normal
                }
            }
            .button {
                @include utils-vertical-center();
                width: px2rem(1140);
                height: px2rem(132);
                text-align: center;
                color: #fff;
                background-color: #38f;
                font-size: px2rem(54);
                border-radius: px2rem(66);
                &.is-reserved-in-tieba {
                    color: #A4A5A7;
                    background-color: #F1F2F4;
                }
            }
        }
    }

    @include b(app-reserve-mask) {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 99;
        background: rgba(153,153,153,0.5);
        display: flex;
        overflow: hidden;
        justify-content: center;
        align-items: center;
        text-align: center;
        .title {
            padding-top: px2rem(70);
            font-size: px2rem(72);
        }
        .words {
            line-height: px2rem(78);
            font-size: px2rem(48);
            color: #999;
            padding: 0 px2rem(60);
        }
        .dialog-size {
            width: px2rem(993);
            background-color: #fff;
            border-radius: px2rem(39);
            position: relative;
        }
        @include e(dialog) {
            height: px2rem(560);
            .words {       
                padding-top: px2rem(10);
            }
            .confirm {
                margin-top: px2rem(65);
                height: px2rem(144);
                line-height: px2rem(144);
                font-size: px2rem(54);
                color: #38f;
                border-top: 1px solid #e0e0e0
            }
        }
        @include e(phone-dialog) {
            height: px2rem(662);
            .input-container {
                display: inline-block;
                width: px2rem(891);
                border: 1px solid #ccc;
                border-radius: px2rem(9);
                padding: px2rem(30) 0;
                box-sizing: border-box;
                font-size: px2rem(54);
                margin-top: px2rem(30);
                .phone-prefix {
                    float: left;
                    width: px2rem(158);
                    color: #999;
                    border-right: 1px solid #e8e8e8;
                }
                .phone-number {
                    width: px2rem(380);
                    float: left;
                    border: none;
                    outline: none;
                    padding-left: px2rem(30);
                    font-size: px2rem(54);
                }      
            }
            .warning {
                font-size: px2rem(42);
                float: left;
                margin-left: px2rem(51);
                color: #da0000;
            }
            .submit {
                position: absolute;
                bottom: 0;
                width: px2rem(993);
                height: px2rem(144);
                line-height: px2rem(144);
                font-size: px2rem(54);
                border-top: 1px solid #e0e0e0;
                div {
                    width: px2rem(492);
                    float: left;
                    &.close {
                        border-right: 1px solid #e0e0e0;
                    }
                    &.confirm {
                        color: #38f;
                    }
                }

            }
        }
        @include e(cancel-reserve-dialog) {
           height: px2rem(450);
           .words {
               padding: px2rem(70) px2rem(120);
           }
           .operation {
                position: absolute;
                bottom: 0;
                width: px2rem(993);
                height: px2rem(144);
                line-height: px2rem(144);
                font-size: px2rem(54);
                border-top: 1px solid #e0e0e0;
                .confirm {
                    width: px2rem(492);
                    float: left;
                    border-right: 1px solid #e0e0e0;
                }
                .close {
                    color: #38f;
                }
           }  
        }
    }
    .tb-reserve-success-toast {
        position: fixed;
        top: px2rem(-200);
        width: px2rem(1164);
        height: px2rem(183);
        left: 50%;
        transform: translateX(-50%);
        background: #FFFFFF;
        box-shadow: 0 px2rem(6) px2rem(18) 0 rgba(146,141,168,0.12);
        border-radius: px2rem(24);
        display: flex;
        align-items: center;
        transition: top 0.5s ease-in;
        &.is-show {
            top: px2rem(60);
        }
        .icon {
            width: px2rem(135);
            height: px2rem(135);
            display: block;
            border-radius: px2rem(36);
            object-fit: cover;
            margin-left: px2rem(24);
        }
        .info {
            margin-left: px2rem(24);
            color: #7559FF;
            .title {
                font-size: px2rem(48);
            }
            .sub-title {
                margin-top: px2rem(9);
                font-size: px2rem(39);
            }
        }
    }
</style>